import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import type { VaultV2ChartTotalDepositFormattedValues } from '../types';
interface ChartHeaderProps {
  currency: string;
  formattedValues: VaultV2ChartTotalDepositFormattedValues;
}
export function ChartHeader(t0) {
  const $ = _c(10);
  const {
    currency,
    formattedValues
  } = t0;
  const {
    formattedValue,
    detailedFormattedValue
  } = formattedValues;
  let t1;
  if ($[0] !== currency) {
    t1 = <div className="flex items-center gap-[2px]"><span className="text-secondary-foreground text-xs">Total Deposits ({currency})</span></div>;
    $[0] = currency;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currency || $[3] !== detailedFormattedValue || $[4] !== formattedValue.unit || $[5] !== formattedValue.value) {
    t2 = formattedValue.value ? <Tooltip><TooltipTrigger asChild={true}><div className="flex w-[fit-content] cursor-default items-center gap-[2px]" data-testid="vault-v2-total-deposits-value"><span className="text-title-sm">{currency === "USD" && formattedValue.value !== "-" ? "$" : ""}{formattedValue.value}</span><span className="text-title-sm text-muted-foreground">{formattedValue.unit}</span></div></TooltipTrigger>{!!detailedFormattedValue && <TooltipContent side="right">{detailedFormattedValue}</TooltipContent>}</Tooltip> : <Skeleton className="h-(--text-title-sm--line-height) w-[130px] rounded-[20px]" />;
    $[2] = currency;
    $[3] = detailedFormattedValue;
    $[4] = formattedValue.unit;
    $[5] = formattedValue.value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="gap-xs flex flex-col">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}